/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, NgModule, ViewEncapsulation, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CheckboxModule, DataTableModule,PanelModule,TabViewModule,ButtonModule,PaginatorModule,DropdownModule,CodeHighlighterModule,FileUploadModule,InputTextModule,ConfirmDialogModule, ConfirmationService} from "primeng/primeng";
import {RouterModule} from "@angular/router";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import { MamAdminService } from '../../service/mam_service.component';

import { App } from '../../model/app';
import { VersionedApp } from '../../model/versionedapp';
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators} from "@angular/forms";
import {SearchModule} from "../../component/search.component";
import {SelectItem} from "primeng/components/common/api";
import {ExDialogModule} from "../../component/dialog.component";
import { AppPlatform } from '../../model/enumModel';
import { ThirdPartyCompany } from '../../model/thirdpartycompany';
import {AppDistributeRemoveModule} from "../../component/app_distribute_remove.component";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import {TranslateServiceForm, TranslatePipeMoudle} from "../../translate";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";

import {FileUpload} from "primeng/components/fileupload/fileupload";

@Component({
  selector: 'app',
  templateUrl: './app_management.html',
  encapsulation: ViewEncapsulation.None
})
export class AppManagementComponent implements OnInit {

  @ViewChild('upload') upload : FileUpload;

  private app_list : VersionedApp[] = [];
  private company_list : ThirdPartyCompany[] = [];
  selectCompany : ThirdPartyCompany;
  selectAppPlatform : AppPlatform;

  activeTabIdx : number = 0;
  app_type : string = "office";

  totalRecord: number;
  searchIDs: SelectItem[];
  table_list: any;

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  sDate: string;
  eDate: string;

  searchText: string;
  searchId : string;
  pageMax:number =10;

  title : string;
  addShow : boolean = false;
  dialogWidth : any;
  selectedValues:string[] =[];
  addForm : FormGroup;

  // 추가, 수정 구분
  action_type : number = 0;

  companys : SelectItem[];
  os : SelectItem[];
  submitted: boolean;

  uploadPath : any;
  appDistributeAndRemoveShow : boolean = false;
  change : number = 0;
  company : any;
  selectOfficeApp : any;
  uploadedFiles : any = [];

  selectedCompany : any;
  ngOnInit() {

    this.getAppList(1,10,"","","",'office');
    this.getCompanyList();

    this.dialogWidth = 600;

    this.os =[];
    this.os.push({label:'-----------',value:null});
    this.os.push({label:'android',value: AppPlatform.ANDROID});
    this.os.push({label:'ios',value: AppPlatform.IOS});
    this.os.push({label:'windows phone',value: AppPlatform.WINDOWS_PHONE});
    this.os.push({label:'windows os',value: AppPlatform.WINDOWS_OS});

    this.selectAppPlatform = AppPlatform.ANDROID;


  }

  constructor(private service : MamAdminService,private fb: FormBuilder, private logger : Logger, private translate : TranslateServiceForm, private confirmationService: ConfirmationService) {
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('AppName'), value: 'name'});
    this.searchIDs.push({label: this.translate.instant('LANG_Platform'), value: 'appType'});
    this.searchIDs.push({label: this.translate.instant('AUDIT_AppService_tag'), value: 'tag'});
    this.searchIDs.push({label: this.translate.instant('AUDIT_VersionedAppService_packageName'), value: 'packageName'});
    this.searchIDs.push({label: this.translate.instant('LANG_APP_FileName'), value: 'binaryFilePath'});

    this.dateIsTrue = false;

    this.addForm = this.fb.group({
      'id' : new FormControl(''),
      'name' : new FormControl('',Validators.required),
      'company' : new FormControl('extrus',Validators.required),
      'osName' : new FormControl('android'),
      'upload' : new FormControl(''),
      'tag' : new FormControl(''),
      'binaryFilePath' : new FormControl('',Validators.required),
      'versionName' : new FormControl('',Validators.required),
      'packageName' : new FormControl('',Validators.required)
    });
    this.uploadPath=this.service.upload();
  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;
    if(this.searchId =="appType"){
      this.getAppList(1, this.pageMax,this.searchText, "false", this.searchId,this.app_type);
    }else{
      this.getAppList(1, this.pageMax,this.searchText, "true", this.searchId,this.app_type);
    }

  }

  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {
      if(this.searchId =="appType"){
        this.getAppList(event.page + 1, event.rows,this.searchText, "false", this.searchId,this.app_type);
      }else{
        this.getAppList(event.page + 1, event.rows,this.searchText, "true", this.searchId,this.app_type);
      }
    } else {

      this.getAppList(event.page + 1,this.pageMax,"","","", this.app_type);

    }

  }
  getCompanyList() {
    this.service.getCompanyList(null,null).subscribe(
        value => {
          this.company_list = value.content;
          this.logger.debug("-- company_list :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.companys = [];
          this.companys.push({label:'-----------',value:null});
          if(this.company_list.length > 0) {
            this.company_list.forEach(company => {
              //this.logger.debug("company :", company);
              this.companys.push({label:company.name, value:company});
            });
            this.selectCompany = this.company_list[0];
          }
        }
    )
  }

  getAppList(page:number, max:number, search:string, like:string, field:string, type:string) {
    this.service.getAppList(page, max, search, like, field, type).subscribe(
        value => {
          this.table_list = value.rows;
          this.totalRecord = value.total;
          this.logger.debug("-- app_list :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
    )
  }

  getWhiteAppAppointment(appId:number, flag:boolean) {
    this.service.getWhiteAppAppointment(appId, flag).subscribe(
        value => {
          var result = value;
          this.logger.debug("-- result :", result);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.getAppList(1,10,"","","", 'none');
        }
    )
  }

  getBlackAppAppointment(appId:number, flag:boolean) {
    this.service.getBlackAppAppointment(appId, flag).subscribe(
        value => {
          var result = value;
          this.logger.debug("-- result :", result);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.getAppList(1,10,"","","", 'none');
        }
    )
  }

  insertApp(kind:string, versionedApp:any) {
    this.service.insertApp(kind, versionedApp).subscribe(
        value => {
          var result = value;
          this.logger.debug("-- result :", result);
          if (result.code == 'MDMx0000') {
            alert("추가 성공");
          }
          else {
            alert("추가 실패");
          }
        },
        error => {
          let result = error.json();
          this.logger.error("-- error : " + error);
          alert(result.message);
          this.addShow = false;
          this.addForm.reset();
        },
        () => {
          this.logger.info("-- complate : ");
          this.addShow = false;
          this.getAppList(1, 10, '', '', '', this.app_type);
        }
    )
  }

  updateApp(appId:number, kind:string, versionedApp:any) {
    this.service.updateApp(appId, kind, versionedApp).subscribe(
        value => {
          var result = value;
          this.logger.debug("-- result :", result);
          if (result.code == 'MDMx0000') {
            alert("추가 성공");
          }
          else {
            alert("추가 실패");
          }
        },
        error => {
          let result = error.json();
          this.logger.error("-- error : " + error);
          alert(result.message);
          this.addShow = false;
          this.addForm.reset();
        },
        () => {
          this.logger.info("-- complate : ");
          this.addShow = false;
          this.addForm.reset();
          this.getAppList(1, 10, '', '', '', this.app_type);
        }
    )
  }

  deleteApp(appId:number) {
    this.service.deleteApp(appId, this.app_type).subscribe(
        value => {

          var result = value;
          if(result instanceof String){
            alert(result);
          }else if(result === '삭제완료'){
            alert(result);
          }else{
            alert(result.RESULT_MESSAGE);
            this.logger.debug("-- result :", result);
          }
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
          this.getAppList(1, 10, '', '', '', this.app_type);
        }
    )
  }


  // ---------------------------------- Event_ --------------------------------
  onTabChange(event) {
    this.activeTabIdx = event.index;
    this.searchIsTrue = false;
    if(this.activeTabIdx == 0 ){
      this.app_type = 'office';
      this.searchIDs.push({label: this.translate.instant('AUDIT_AppService_tag'), value: 'tag'});

    } else if( this.activeTabIdx == 1) {
      this.app_type = 'white';
      this.searchIDs = [];
      this.searchIDs.push({label: '---------------', value: 'all'});
      this.searchIDs.push({label: this.translate.instant('AppName'), value: 'name'});
      this.searchIDs.push({label: this.translate.instant('LANG_Platform'), value: 'appType'});
      this.searchIDs.push({label: this.translate.instant('AUDIT_VersionedAppService_packageName'), value: 'packageName'});
      this.searchIDs.push({label: this.translate.instant('LANG_APP_FileName'), value: 'binaryFilePath'});


    } else if( this.activeTabIdx == 2) {
      this.app_type = 'black';
      this.searchIDs = [];
      this.searchIDs.push({label: '---------------', value: 'all'});
      this.searchIDs.push({label: this.translate.instant('AppName'), value: 'name'});
      this.searchIDs.push({label: this.translate.instant('LANG_Platform'), value: 'appType'});
      this.searchIDs.push({label: this.translate.instant('AUDIT_VersionedAppService_packageName'), value: 'packageName'});
      this.searchIDs.push({label: this.translate.instant('LANG_APP_FileName'), value: 'binaryFilePath'});

    } else if( this.activeTabIdx == 3) {
      this.app_type = 'none';
      this.searchIDs = [];
      this.searchIDs.push({label: '---------------', value: 'all'});
      this.searchIDs.push({label: this.translate.instant('AppName'), value: 'name'});
      this.searchIDs.push({label: this.translate.instant('LANG_Platform'), value: 'appType'});
      this.searchIDs.push({label: this.translate.instant('AUDIT_VersionedAppService_packageName'), value: 'packageName'});
      this.searchIDs.push({label: this.translate.instant('LANG_APP_FileName'), value: 'binaryFilePath'});
    }
    this.getAppList(1,10,"","","", this.app_type);

  }

  onSelectedCompany(company) {
    this.selectedCompany = company;
    this.logger.debug("combo - select :" , this.selectedCompany);
  }

  appAdd(event){
    this.addShow = true;
    this.addForm.reset();

    this.addForm.get("name").setValue("");
    this.addForm.get('binaryFilePath').setValue("");
    this.selectAppPlatform= null;
    this.selectCompany = null;

    this.uploadedFiles = [];
    // insert
    this.action_type = 0;

    if(event == 0){
      this.title = this.translate.instant('LANG_APP_OfficeAppAdd');

    }else if(event == 1){
      this.title = this.translate.instant('LANG_APP_WhiteAppAdd');

    }else if(event == 2){
      this.title = this.translate.instant('LANG_APP_BlackAppAdd');
    }
  }

  appUpdate(rowData) {
    this.logger.debug("rowData",rowData);
    this.addShow = true;
    this.action_type = 1;
    this.uploadedFiles = [];
    if(this.app_type == 'office') this.title = this.translate.instant('LANG_modifyOfficeApp');
    else if(this.app_type == 'white') this.title = this.translate.instant('LANG_modifyWhiteApp');
    else if(this.app_type == 'black') this.title = this.translate.instant('LANG_modifyBlackApp');
    else this.title = this.translate.instant('LANG_modifyNoneApp');

    this.addForm.controls['id'].setValue(rowData.id);
    this.addForm.controls['name'].setValue(rowData.name);
    this.addForm.controls['company'].setValue(rowData.company);
    if(rowData.appType == "ANDROID") this.addForm.controls['osName'].setValue(AppPlatform.ANDROID);
    else if(rowData.appType == "IOS") this.addForm.controls['osName'].setValue(AppPlatform.IOS);
    else if(rowData.appType == "WINDOWS_OS") this.addForm.controls['osName'].setValue(AppPlatform.WINDOWS_OS);
    else if(rowData.appType == "WINDOWS_PHONE") this.addForm.controls['osName'].setValue(AppPlatform.WINDOWS_PHONE);
    this.addForm.controls['binaryFilePath'].setValue(rowData.binaryFilePath);
    this.addForm.controls['versionName'].setValue(rowData.versionName);
    this.addForm.controls['packageName'].setValue(rowData.packageName);
    this.addForm.controls['tag'].setValue(rowData.tag);

  }

  cancel(){
    this.addShow = false;
  }
  onSubmit(value){
    this.logger.debug("value :", value);
    let valid_android = value.binaryFilePath.match(".apk");
    let valid_ios = value.binaryFilePath.match(".ipa");



    if(valid_android != null && valid_android.length >= 1) {
      this.selectAppPlatform = AppPlatform.ANDROID;
    }
    if(valid_ios != null && valid_ios.length >= 1) {
      this.selectAppPlatform = AppPlatform.IOS;
    }

    var versionedAppModel = {
      id : value.id,
      name : value.name,
      binaryFilePath  : value.binaryFilePath,
      packageName : value.packageName,
      versionName : value.versionName,
      appType : this.selectAppPlatform,
      company : this.selectCompany,
      tag : value.tag
    }
    if(this.action_type == 0) this.insertApp(this.app_type, versionedAppModel);
    else this.updateApp(value.id, this.app_type, versionedAppModel);
    this.submitted = true;
  }

  /*onSelects(event) {
    var fileName = "";
    for(let file of event.files) {
      fileName = file.name;
    }

    this.confirmationService.confirm({
      header: this.translate.instant('LANG_File_Upload'),
      message: fileName + " " + this.translate.instant('LANG_File_Upload_Confirm'),
      icon: 'fa',
      accept: () => {
        this.upload.url = this.uploadPath;
        this.upload.upload();
      },
      reject: () => {
        this.upload.clear();
        this.addForm.get('binaryFilePath').setValue("");
        this.uploadedFiles = [];
      }
    });
  }*/

  onUploads(event) {
    for(let file of event.files) {
      this.logger.debug("file :", file.name);
      this.addForm.controls['binaryFilePath'].setValue(file.name);
      this.uploadedFiles.push(file);
    }
  }

  onBeforeSend(event) {
    event.xhr.withCredentials = true;
  }

  setWhiteApp(data) {
    this.getWhiteAppAppointment(data.id, true);
  }

  setBlackApp(data) {
    this.getBlackAppAppointment(data.id, true);
  }

  onOsTypeChange(event) {
    this.logger.debug("onOsTypeChange : ", event);
  }

  onCompanyChange(event) {
    this.logger.debug("onCompanyChage : ", event);
  }

  appDistributeOrRemove(item) {

    if (this.selectOfficeApp) {
      this.logger.debug("선택된 오피스앱",this.selectOfficeApp);
      this.company = this.selectOfficeApp.company;
      this.appDistributeAndRemoveShow = true;
      if (item == "distribute") {
        this.title = this.translate.instant('LANG_APP_publish');
        this.change++;
      } else if (item == "remove") {
        this.title = this.translate.instant('LANG_APP_remove');
        this.change--;
      }

    } else {
      alert(this.translate.instant('LANG_plzSelctOneRow'));
    }
  }


}

@NgModule({
  imports: [CheckboxModule, DataTableModule,TabViewModule,PanelModule,BrowserModule,HttpModule, RouterModule,ButtonModule, CommonModule,PaginatorModule,DropdownModule,FormsModule,SearchModule,ExDialogModule,CodeHighlighterModule,FileUploadModule,InputTextModule,ReactiveFormsModule,AppDistributeRemoveModule,TranslatePipeMoudle, CompanyDropDownListModule,ConfirmDialogModule],
  exports: [AppManagementComponent],
  declarations: [AppManagementComponent],
  providers: [MamAdminService, ConfirmationService],
})
export class AppManagementModule {
}



// WEBPACK FOOTER //
// ./src/app/page/device/app_management.ts